(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  const CARD_SELECTOR = '.t4s-product';

  function getProductUrl(card) {
    const productLink =
      card.querySelector('a.t4s-full-width-link[href*="/products/"]') ||
      card.querySelector('.t4s-product-title a[href*="/products/"]') ||
      card.querySelector('.t4s-product__title a[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');

    return productLink ? productLink.href : null;
  }

  function isTargetButton(el) {
    if (!el || !el.matches('a, button')) return false;

    const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

    return (
      text.includes('add to cart') ||
      text.includes('select options') ||
      el.matches('.t4s-pr-addtocart, [data-atc-selector], [data-product-btn]')
    );
  }

  function updateCard(card) {
    const productUrl = getProductUrl(card);
    if (!productUrl) return;

    card.querySelectorAll('a, button').forEach(function (el) {
      if (!isTargetButton(el)) return;

      const textNode =
        el.querySelector('.t4s-btn-atc_text') ||
        el.querySelector('[data-atc-text]') ||
        el.querySelector('span:not(.t4s-svg-pr-icon):not(.t4s-loading__spinner)');

      if (textNode) {
        textNode.textContent = 'SHOP NOW';
      } else {
        // Preserve existing icon elements where possible.
        const textNodes = Array.from(el.childNodes).filter(function (node) {
          return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
        });
        if (textNodes.length) {
          textNodes.forEach(function (node, index) {
            if (index === 0) node.textContent = ' SHOP NOW ';
            else node.textContent = '';
          });
        } else {
          el.insertAdjacentText('beforeend', ' SHOP NOW');
        }
      }

      el.setAttribute('data-shop-now-url', productUrl);

      if (el.tagName === 'A') {
        el.setAttribute('href', productUrl);
        el.removeAttribute('data-variant-id');
        el.removeAttribute('data-product-id');
      }
    });
  }

  function updateAllCards(root) {
    const scope = root || document;
    scope.querySelectorAll(CARD_SELECTOR).forEach(updateCard);
  }

  document.addEventListener('click', function (event) {
    const target = event.target.closest('[data-shop-now-url]');
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = target.getAttribute('data-shop-now-url');
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    updateAllCards(document);

    // Re-apply after AJAX filtering, sorting, pagination, or load-more updates.
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches && node.matches(CARD_SELECTOR)) {
            updateCard(node);
          } else if (node.querySelectorAll) {
            updateAllCards(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
